module.exports = __webpack_public_path__ + "static/img/bg-pc-web04@m.a2fbe0c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-archive/bg-pc-web04@m.png
// module id = lOta
// module chunks = 0